import { Route, Routes } from '@angular/router';

const treatmentRoute: Route = {
    loadChildren: () => import('./pages/treatment/treatment.routing').then(m => m.TreatmentRoutes),
};

export const AppRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        ...treatmentRoute,
    },
    {
        path: 'treatment',
        ...treatmentRoute,
    },
    {
        path: 'app-settings',
        loadChildren: () => import('./pages/app-settings').then(x => x.AppSettingsRoutes),
    },
    {
        path: 'manage-message-templates',
        loadChildren: () => import('./pages/manage-message-templates-entry').then(x => x.ManageMessageTemplatesRoutes),
    },
    {
        path: 'manage-qc-checklist-templates',
        loadChildren: () =>
            import('./pages/manage-qc-checklist-templates').then(
                x => x.ManageQCChecklistTemplatesRoutes
            ),
    },
    {
        path: 'manage-required-design-file-templates',
        loadChildren: () =>
            import('./pages/manage-required-design-file-templates').then(
                x => x.ManageRequiredDesignFileTemplatesRoutes
            ),
    },
    {
        path: 'manage-treatment-type-groups',
        loadChildren: () =>
            import('./pages/manage-treatment-type-groups').then(
                x => x.ManageTreatmentTypeGroupsRoutes
            ),
    },
    {
        path: 'manage-shift-roster',
        loadChildren: () => import('./pages/manage-shift-roster').then(x => x.ManageShiftRosterRoutes),
    },
    {
        path: 'manage-treatment-assignment-rules',
        loadChildren: () =>
            import('./pages/manage-treatment-assignment-rules').then(
                x => x.ManageTreatmentAssignmentRulesRoutes
            ),
    },
    {
        path: 'treatment-auto-assign-jobs',
        loadChildren: () =>
            import('./pages/treatment-auto-assign-jobs').then(x => x.TreatmentAutoAssignJobsRoutes),
    },
    {
        path: '403.html',
        loadComponent: () => import('./pages/common').then(x => x.ForbiddenComponent),
    },
    {
        path: 'admin/members',
        loadChildren: () => import('./pages/member').then(x => x.MemberRoutes),
    },
    {
        path: 'data-insights',
        loadChildren: () => import('./pages/data-insights').then(x => x.DataInsightsRoutes),
    },
    {
        path: 'manage-doctor-preferences',
        loadChildren: () =>
            import('./pages/manage-doctor-preferences').then(x => x.ManageDoctorPreferencesRoutes),
    },
];
